import React from 'react'
import LevelOneCategoryListContainer from '../../../../Components/Category/LevelOneCategoryList/LevelOneCategoryListContainer'
import Layout from '../../Layout'

const LevelOneCategoryListPart = () => {
  return (
    <Layout>
        <LevelOneCategoryListContainer/>
    </Layout>
  )
}

export default LevelOneCategoryListPart